var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCardHeader',[_vm._v(" "+_vm._s(_vm.title)+" - "+_vm._s(_vm.rows)+" rows")])}
var staticRenderFns = []

export { render, staticRenderFns }